import { useState, useEffect } from "react";

/**
 * Custom hook to persist form data in localStorage
 * @param {string} LOCAL_KEY - The key used in localStorage
 * @param {any} initialValue - The initial value to use if no stored data is found
 * @returns {[any, Function]} - [formData, setFormData]
 */
export default function usePersistentForm(LOCAL_KEY, initialValue) {
  const [formData, setFormData] = useState(() => {
    try {
      const saved = localStorage.getItem(LOCAL_KEY);
      return saved ? JSON.parse(saved) : initialValue;
    } catch (err) {
      console.error("Error parsing localStorage value:", err);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(LOCAL_KEY, JSON.stringify(formData));
    } catch (err) {
      console.error("Error saving to localStorage:", err);
    }
  }, [LOCAL_KEY, formData]);

  return [formData, setFormData];
}


export function usePersistentState(key, initialValue) {
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : initialValue;
  });

  // Save to localStorage on change
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(formData));
  }, [formData]);

  return [formData, setFormData];
}


export function usePersistentJsonState(key, initialValue) {
  const [state, setState] = useState(() => {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : initialValue;
    } catch (error) {
      console.error("Error reading JSON from localStorage", error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error("Error writing JSON to localStorage", error);
    }
  }, [key, state]);

  return [state, setState];
}